/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from '@mui/material/Card'
import Divider from '@mui/material/Divider'

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDButton from 'components/MDButton'
import MDBadge from 'components/MDBadge'
import env from '../../../../../../../config'
import Swal from 'sweetalert2'

function Authentication({ data }) {
  console.log("data", data)
  const copyToClipboard = (url) => {
    const text = url

    // Create a temporary textarea element to hold the text
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.setAttribute('readonly', '')
    textarea.style.position = 'absolute'
    textarea.style.left = '-9999px'
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand('copy')
    document.body.removeChild(textarea)
  }
  const handleInstall = () => {
    const url = `https://marketplace.gohighlevel.com/oauth/chooselocation?response_type=code&redirect_uri=${env.GHL.REDIRECT.APP_CREATOR_LOCATION_ASSOCIATE}&client_id=${env.GHL.APP_CREATOR_LOCATION_CLIENT_ID}&scope=${env.GHL.APP_CREATOR_LOCATION_SCOPE}&state=${data._id}`

    window.open(
      url,
      '_blank',
      'width=500,height=500,toolbar=no,menubar=no,scrollbars=yes,resizable=yes'
    )
  }

  const handleInfoClick = () => {
    const curlCommand = `curl --location 'https://webhook.ghl.store/api/v1/app_token/getsnapshotstoken/${data?.app_id}' \\
--header 'Content-Type: application/json' \\
--data '{
  ${!data.agency_type ? `"location_id": "${data?.location_id}",\n  ` : ''}
  "company_id": "${data?.ghl?.company_id}"
}'`;

    Swal.fire({
      title: 'CURL',
      html: `
      <div style="text-align:left; background:#f5f5f5; padding:10px; border-radius:6px; position:relative; font-size:13px;">
        <pre style="white-space:pre-wrap; word-break:break-word; margin:0;">${curlCommand}</pre>
        <button id="copyCurlBtn" style="
          position:absolute;
          top:10px;
          right:10px;
          background:none;
          border:none;
          cursor:pointer;
          font-size:16px;
        " title="Copy to clipboard">📋</button>
      </div>
      <hr/>
      <ul style="text-align:left; font-size:14px; padding-left:20px;">
        <li style="margin-bottom:10px"><strong>Header:</strong> Uses <code>Content-Type: application/json</code> for sending JSON data.</li>
        <li style="margin-bottom:10px"><strong>location_id:</strong> Only sent if the app is not agency type.</li>
        <li style="margin-bottom:10px"><strong>company_id:</strong> Required to identify the company in GHL.</li>
        <li style="margin-bottom:10px"><strong>Purpose:</strong>  Get New Refresh Token </li>
      </ul>
    `,
      showConfirmButton: true,
      confirmButtonText: 'Got it!',
      width: 700,
      didOpen: () => {
        const copyBtn = document.getElementById('copyCurlBtn');
        copyBtn.addEventListener('click', () => {
          navigator.clipboard.writeText(curlCommand);
          copyBtn.textContent = '✅';
          setTimeout(() => (copyBtn.textContent = '📋'), 1500);
        });
      },
    });
  };



  return (
    <Card id="app-setup" sx={{ overflow: 'visible' }}>
      <MDBox p={3} lineHeight={1}>
        <MDBox mb={1}>
          <MDTypography variant="h5">Marketplace App Setup</MDTypography>
        </MDBox>
        <MDTypography variant="button" color="text">
          Following configurations Needs to added in your marketplace app
        </MDTypography>
      </MDBox>
      <MDBox p={3}>
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          flexDirection={{ xs: 'column', sm: 'row' }}
        >
          <MDTypography variant="body2" color="text">
            Connect Your Location
          </MDTypography>
          <MDBox
            display="flex"
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            flexDirection={{ xs: 'column', sm: 'row' }}
          >
            <MDButton variant="outlined" color="dark" size="small" onClick={handleInstall}>
              {data?.ghl ? 'Connected' : 'Connect'}
            </MDButton>
          </MDBox>
        </MDBox>
        <Divider />
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          flexDirection={{ xs: 'column', sm: 'row' }}
        >
          <MDTypography variant="body2" color="text">
            Custom Page Url
          </MDTypography>
          <MDBox
            display="flex"
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            flexDirection={{ xs: 'column', sm: 'row' }}
          >
            <MDButton
              variant="outlined"
              color="dark"
              size="small"
              onClick={() =>
                copyToClipboard(
                  `https://snapshotonboarding.levelupmarketplace.io/${data?.app_id}/onboarding/custom_page`
                )
              }
            >
              Copy
            </MDButton>
          </MDBox>
        </MDBox>
        <Divider />
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          flexDirection={{ xs: 'column', sm: 'row' }}
        >
          <MDTypography variant="body2" color="text">
            Webhook Url
          </MDTypography>
          <MDBox
            display="flex"
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            flexDirection={{ xs: 'column', sm: 'row' }}
          >
            <MDButton
              variant="outlined"
              color="dark"
              size="small"
              onClick={() =>
                copyToClipboard(
                  `https://marketplace.ghl.store/api/v1/webhook/snapshot_onboarding_installevent`
                )
              }
            >
              Copy
            </MDButton>
          </MDBox>
        </MDBox>
        <Divider />
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          flexDirection={{ xs: 'column', sm: 'row' }}
        >
          <MDTypography variant="body2" color="text">
            Redirect Url
          </MDTypography>
          <MDBox
            display="flex"
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            flexDirection={{ xs: 'column', sm: 'row' }}
          >
            <MDButton
              variant="outlined"
              color="dark"
              size="small"
              onClick={() =>
                copyToClipboard(
                  `https://snapshotonboarding.levelupmarketplace.io/integrations/auth/snapshot_onboarding/${data.app_id}`
                )
              }
            >
              Copy
            </MDButton>
          </MDBox>
        </MDBox>
        <Divider />
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          flexDirection={{ xs: 'column', sm: 'row' }}
        >
          <MDTypography variant="body2" color="text">
            Custom App
          </MDTypography>
          <MDBox
            display="flex"
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            flexDirection={{ xs: 'column', sm: 'row', }}
            gap={1}
          >
            <MDButton
              variant="outlined"
              color="dark"
              size="small"
              onClick={() =>
                copyToClipboard(
                  `curl --location 'https://webhook.ghl.store/api/v1/app_token/getsnapshotstoken/${data?.app_id}' \\
--header 'Content-Type: application/json' \\
--data '{
    ${!data.agency_type ? `"location_id": "${data?.location_id}",` : ""}
    "company_id": "${data?.ghl?.company_id}"
}'`
                )
              }

            >
              Copy
            </MDButton>
            <MDButton
              variant="contained"
              color="info"
              size="small"
              onClick={handleInfoClick}



            >
              Info
            </MDButton>
          </MDBox>
        </MDBox>

      </MDBox>
    </Card>
  )
}

export default Authentication
